export default __webpack_public_path__ + "static/3-3ee57e4a26214b562dcb24f2a4136e98.jpg";